"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var b=require("react"),c=require("styled-components"),a=require("../fonts.js");function d(a){return a&&"object"==typeof a&&"default"in a?a:{default:a}}var f=d(b);function g(){return(g=Object.assign||function(d){for(var a=1;a<arguments.length;a++){var b=arguments[a];for(var c in b)Object.prototype.hasOwnProperty.call(b,c)&&(d[c]=b[c])}return d}).apply(this,arguments)}let h=c.createGlobalStyle`
  @font-face {
    font-family: "CircularXXWeb-Bold";
    src: url(${a.CircularXXWebBold}) format("woff");
  }

  @font-face {
    font-family: "CircularXXWeb-Book";
    src: url(${a.CircularXXWebBook}) format("woff");
  }

  @font-face {
    font-family: "CircularXXWeb-Medium";
    src: url(${a.CircularXXWebMedium}) format("woff");
  }

  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: ${({theme:a})=>a.typography.fontFamily};
  }

  body.fontLoaded {
    font-family: ${({theme:a})=>`'Lato', ${a.typography.fontFamily}`};
  }
`;const e=({...a})=>f.default.createElement(h,g({},a));exports.GlobalStyle=e
//# sourceMappingURL=GlobalStyle.js.map
